import { render } from "./BlankPageSalesSix.vue?vue&type=template&id=51aaa683&scoped=true"
import script from "./BlankPageSalesSix.vue?vue&type=script&lang=js"
export * from "./BlankPageSalesSix.vue?vue&type=script&lang=js"

import "./BlankPageSalesSix.vue?vue&type=style&index=0&id=51aaa683&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51aaa683"]])

export default __exports__